<template>
  <div>
    <b-form>
      <b-modal id="new-tenant-modal" title="Créer une agence" @hide="onClose">
        <b-form-group label="Agence" label-for="agencyName">
          <b-form-input
            id="agencyName"
            v-model="agencyName"
            data-cy="new-groupe-modal-name-input"
            placeholder="Entrez un nom"
            required
            :state="isNameValid"
            @input="validateName"
          ></b-form-input>
        </b-form-group>
        <template v-slot:modal-footer>
          <b-button variant="secondary" @click="onClose"> Annuler </b-button>
          <b-button
            type="submit"
            variant="primary"
            data-cy="new-tenant-modal-submit-btn"
            @click="onSubmit"
            >Créer</b-button
          >
        </template>
      </b-modal>
    </b-form>
  </div>
</template>

<script>
export default {
  name: 'newTenantPopup',

  props: {
    groups: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      agencyName: null,
      group: 'pvstudio',
      isNameValid: null,
    };
  },

  methods: {
    onSubmit() {
      this.validateName();

      if (this.isNameValid) {
        this.$emit('form-submitted', {
          agencyName: this.agencyName,
          group: this.group,
        });
        this.$bvModal.hide('new-tenant-modal');
      }
    },
    validateName() {
      this.isNameValid = this.agencyName ? true : false;
    },
    onClose() {
      this.$bvModal.hide('new-tenant-modal');
      this.isNameValid = null;
      this.name = null;
      this.group = null;
    },
  },
};
</script>
